import { combineReducers } from 'redux';

import Global from './Global/GlobalReducer';
// import Api from './Api/ApiReducer';
import Notebooks from './Notebooks/NotebooksReducer';
import Notes from './Notes/NotesReducer';
import User from './User/UserReducer';
import NoteContent from './NoteContent/NoteContentReducer';
import NoteHistory from './NoteHistory/NoteHistoryReducer';
import TrashNotes from './Trash/TrashNotesReducer';

const RootReducer = combineReducers({
  Global,
  // Api, // 已废弃
  Notebooks,
  Notes,
  User,
  NoteContent,
  NoteHistory,
  TrashNotes,
});

export default RootReducer;



// WEBPACK FOOTER //
// ./src/reducers/rootReducer.js